import { render } from "./AcceptOrder.vue?vue&type=template&id=e2746462&scoped=true"
import script from "./AcceptOrder.vue?vue&type=script&lang=js"
export * from "./AcceptOrder.vue?vue&type=script&lang=js"

import "./AcceptOrder.vue?vue&type=style&index=0&id=e2746462&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2746462"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QInnerLoading from 'quasar/src/components/inner-loading/QInnerLoading.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QInnerLoading});
